import { useAppSelector } from '../../store/hooks';
import MenuUtils from '../../utils/MenuUtils';
import ExportPage from '../ExportPage';
import HomePage from '../HomePage';
import AbsencesYearPage from '../absences/AbsencesYearPage';
import UserHomePage from '../home/UserHomePage';
import FAQPage from '../legal/FAQPage';
import { default as PolicyPage, default as TermsPage } from '../legal/PolicyPage';
import ProfileSettingsTabs from '../settings/ProfileSettingsTabs';
import TimeHistoryPage from '../time/TimeHistoryPage';
import TimeInputPage from '../time/TimeInputPage';

const NavigationRouter = () => {
  const { item } = useAppSelector((state) => state.menu);
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  if (loggedIn === false) return <HomePage />;

  switch (item) {
    case MenuUtils.UserHome:
      return <UserHomePage />;
    case MenuUtils.TimeHistory:
      return <TimeHistoryPage />;
    case MenuUtils.TimeInput:
      return <TimeInputPage />;
    case MenuUtils.Flyout:
      return <>?</>;
    case MenuUtils.Profile:
      return <ProfileSettingsTabs />;
    case MenuUtils.Report:
      return <ExportPage />;
    case MenuUtils.Absence:
      return <AbsencesYearPage />;
    case MenuUtils.Privacy:
      return <PolicyPage />;
    case MenuUtils.Terms:
      return <TermsPage />;
    case MenuUtils.FAQ:
      return <FAQPage />;
    default:
      return null;
  }
};
export default NavigationRouter;
